<div class="h-100 overflow-auto crm-scroll">
  <div class="d-flex flex-row align-items-center justify-content-between px-4 py-3 bg-white position-sticky top-0 z-5">
    <h4 class="m-0 text-crm">{{ 'ticket_system.ticket' | translate }}: {{ title }}</h4>

    @if (baseService.isMobile) {
      <app-button [btnType]="'icon'" matTooltip="{{ 'close' | translate }}" (onChangeClick)="closeBar()">
        <app-icon>close</app-icon>
      </app-button>
    }
  </div>

  <mat-divider class="my-2"></mat-divider>

  @if (isLoader) {
    <div class="d-flex justify-content-center">
      <app-loader size="small"></app-loader>
    </div>
  } @else {
    @for (message of messages; track message; let i = $index) {
      <div class="d-flex flex-column p-3">
        <mat-card class="ticket-list-card text-black w-100 p-3 overflow-auto crm-scroll">
          <mat-card-header class="ticket-header d-flex justify-content-between">
            <mat-card-title class="text-center w-100">
              #{{ messages.length - i }} {{ 'ticket_system.message' | translate }}: {{ formatDate(message.created_at) }}
            </mat-card-title>
            @if (message.role === 'MANAGE') {
              <h6 class="text-crm">Адміністратор</h6>
            }
          </mat-card-header>
          <mat-card-content class="d-flex flex-column gap-1 ticket-list crm-scroll">
            <p>{{ message.text }}</p>
            @if (message.attachment) {
              <div class="d-flex flex-column w-100">
                <div
                  class="image-list d-flex justify-content-center flex-wrap gap-2 w-100"
                  [appPhotoGalleryGroup]="{ clickMode: 'single' }"
                >
                  @for (img of message.attachment; track img; let i = $index) {
                    <div class="img-box">
                      <img
                        [appPhotoGallery]="{ url: img.url, mimeType: 'image/png' }"
                        class="container-img"
                        [src]="img.url"
                        alt="{{ i }}"
                      />
                    </div>
                  }
                </div>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
    }
  }

  <div class="d-flex p-3 w-100 position-sticky bottom-0">
    <mat-card class="w-100">
      <div class="d-flex justify-content-between align-items-center">
        <div class="bg-white m-2 rounded-2 d-flex flex-column" style="width: 100%">
          <div class="w-100" style="padding: 5px">
            <div>
              <textarea
                #textArea
                type="text"
                autocomplete="off"
                [cdkTextareaAutosize]="true"
                placeholder="{{ 'write_a_message' | translate }}..."
                (keydown.enter)="pressEnter($event)"
                (keydown.meta.enter)="pressCmdEnter($event)"
                (keydown.control.enter)="pressCmdEnter($event)"
                (keydown.shift.enter)="pressShiftEnter($event)"
                [formControl]="ticketForm.controls.text"
                class="w-100 crm-scroll current-chat-input border-0 p-0 pe-2"
                [ngStyle]="{ 'max-height': baseService.isMobile ? '150px' : '250px' }"
              ></textarea>
            </div>
          </div>
          <div class="d-flex justify-content-between pe-2">
            <div class="d-flex flex-row align-items-center gap-2">
              <label class="small-icon click-css">
                <app-button (onChangeClick)="openFileUpload()" btnType="icon"
                  ><app-icon class="small-icon">image</app-icon></app-button
                >
              </label>
            </div>

            <app-button btnType="icon-bg" (onChangeClick)="sendMessage()" [disabled]="ticketForm.invalid">
              <app-icon>send</app-icon>
            </app-button>
          </div>
          @if (ticketFiles.length) {
            <div class="d-flex flex-column w-100">
              <mat-card-header class="ticket-header">
                <mat-card-title class="text-center w-100 justify-content-center">{{
                  'ticket_system.files' | translate
                }}</mat-card-title>
              </mat-card-header>
              <div class="image-list d-flex justify-content-center flex-wrap gap-2 w-100">
                @for (img of ticketFiles; track img; let i = $index) {
                  <div class="img-box">
                    <app-button btnType="icon" class="deletePhoto" (click)="deletePhoto(i)">
                      <app-icon>delete</app-icon>
                    </app-button>
                    <img class="container-img no-select" [src]="img.url" alt="{{ i }}" />
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </mat-card>
  </div>
</div>
